export default {
  getCurrencyCode: state => {
    return state.currencyCode || [];
  },

};
